export default "__VITE_ASSET__DsHcbrQ___"